import React from 'react';
import styled from 'styled-components';
import { Icon } from '@ontruck/orc';
import { useTranslation } from 'react-i18next';

const Text = styled.div`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  display: block; ;
`;

const Bold = styled.div`
  font-weight: 500;
`;

const Accent = styled.span`
  color: #fcc475;
`;

const TextWithIcon = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

const IconContainer = styled.div`
  width: 18px;
  height: 18px;
  svg {
    fill: var(--accent500);
  }
`;

const SoHandlingTooltipDefault = ({ className }) => {
  const { t } = useTranslation('Catalog');

  return (
    <div className={className}>
      <Text>
        <Bold>
          <Accent>{t('complements.handling_tooltip_default.line1')}</Accent>
        </Bold>
      </Text>
      <Text>
        {t('complements.handling_tooltip_default.line2')}{' '}
        <b>{t('complements.handling_tooltip_default.line3')}</b>
        {t('complements.handling_tooltip_default.line4')}
      </Text>
      <TextWithIcon>
        <IconContainer>
          <Icon glyph="handling" size={'18px'} />
        </IconContainer>
        <Text>
          {t('complements.handling_tooltip_default.line5')}{' '}
          <Accent>{t('complements.handling_tooltip_default.line6')} </Accent>
          {t('complements.handling_tooltip_default.line7')}
        </Text>
      </TextWithIcon>
    </div>
  );
};

export default styled(SoHandlingTooltipDefault)`
  display: flex;
  flex-direction: column;
  padding: 12px 16px;
  gap: 12px;
`;
